import React from 'react';
type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  className?: string;
  action?: React.ReactNode;
};

/**
 * Editorial section header.
 * Eyebrow = Gotham Bold caps +200 · Title = DM Serif Display · Sub = Gotham Light
 */
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  tone = 'dark',
  className = '',
  action
}: Props) {
  const centered = align === 'center';
  return <div className={`flex flex-col gap-6 md:flex-row md:items-end ${centered ? 'md:justify-center' : 'md:justify-between'} ${className}`} data-id="element-223" data-mp="gj6sv5her3gb">
      <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-224" data-mp="1shha201bmbx">
        {eyebrow && <p className={`type-eyebrow mb-4 text-[11px] ${tone === 'dark' ? 'text-pennant' : 'text-paper/60'}`} data-id="element-225" data-mp="6raiow21rmvq">
            {eyebrow}
          </p>}
        <h2 className={`type-display text-4xl md:text-5xl ${tone === 'dark' ? 'text-coffee' : 'text-paper'}`} data-id="element-226" data-mp="zbsiv95mvzsz">
          {title}
        </h2>
        {subtitle && <p className={`type-body mt-5 text-base ${tone === 'dark' ? 'text-ink/65' : 'text-paper/65'} ${centered ? 'mx-auto max-w-xl' : 'max-w-xl'}`} data-id="element-227" data-mp="22zihexx5g4dc">
            {subtitle}
          </p>}
      </div>
      {action && <div className="shrink-0" data-id="element-228" data-mp="2c2jop1xr41il">{action}</div>}
    </div>;
}